import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import {
  createGroup,
  deleteGroup,
  getGroups,
  updateGroup,
} from '../apis/group.api';
import { queryKey } from '../constants/queryClientKey';

export function useGetGroups(
  params: Parameters<typeof getGroups>[0],
  options?: any
) {
  return useQuery(
    [queryKey.groups, sortObjectKeys(params)],
    () => getGroups(params),
    {
      ...options,
    }
  );
}

export function useCreateGroup() {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: Parameters<typeof createGroup>[0]) => createGroup(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.groups]);
      },
      onError: (err) => {
        console.error('useCreateGroup:', err);
      },
    }
  );
}

type ParamsUpdateGroup = Parameters<typeof updateGroup>;
export function useUpdateGroup() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({
      id,
      data,
    }: {
      id: ParamsUpdateGroup[0];
      data: ParamsUpdateGroup[1];
    }) => updateGroup(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.groups]);
      },

      onError: (err) => {
        console.error('useUpdateGroup:', err);
      },
    }
  );
}

export function useDeleteGroup() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deleteGroup(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.groups]);
    },
    onError: (err) => {
      console.error('useDeleteGroup:', err);
    },
  });
}
